<template>
  <CCard class="mb-0 pointer navigation_card" @click="openSidebarRight('loyalty_store_category_details', { loyalty_store_category_id_external: categoryData.loyalty_store_category_id_external });">
    <CCardBody>
      <div class="d-flex align-items-center">
        <div v-if="categoryData.category_image_id"
            class="item_image mr-2"
            v-bind:style="{ backgroundImage: 'url(' + apiBaseUrl + '/v1/common/cdn/file/image/loyalty-store-category/' + categoryData.loyalty_store_category_id_external + '/' + categoryData.category_image_id + '.jpg' + '/' + clientToken + ')' }">
        </div>
        <div v-else class="item_icon d-inline-block align-middle mr-2">
          <i class="fas fa-list"/>               
        </div>                        
        <div class="flex-grow-1">
          <span><b>{{categoryData.loyalty_store_category_name}}</b></span>
          <div class="meta">
            <span>{{categoryData.nr_of_products}} {{categoryData.nr_of_products !== 1 ? $t('common.products') : $t('common.product')}}</span>
          </div>
        </div>
      </div>
    </CCardBody>
  </CCard>
</template>

<script>

export default {
  name: 'loyaltyStoreCategoryCard',
  props: ['category'],
  watch: {
    $props: {
      handler() {
        if(this.category) this.categoryData = this.category;
      },
      deep: true,
      immediate: true,
    }
  },
  data() {
    return {
      apiBaseUrl: null,
      clientToken: null,
      categoryData: {}
    }
  },
  mounted: function() {
    this.apiBaseUrl = process.env.VUE_APP_API_URL;
    this.clientToken = localStorage.getItem('token');
  }  
}
</script>
